import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ElectionService } from 'src/app/services/election.service';
import { fromEvent, interval, Subject } from 'rxjs';
import { MyMonitoringService } from 'src/app/services/logging.service';
import { PageTypeEnum } from 'src/app/enums/PageTypeEnum';
import { IImageFrame } from 'src/app/interfaces/IImageFrame';
import { take, takeUntil } from 'rxjs/operators';
import { DeviceDetectorService } from 'ngx-device-detector';
import { SubTitleService } from 'src/app/services/subTitleService';


@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent implements OnInit, OnDestroy {

  private componentDestroyed$: Subject<boolean> = new Subject<boolean>();

  public subTitle = '';
  public PageTypeEnum = PageTypeEnum;
  public showSideNav = false;

  public isMobile = false;
  public isTablet = false;
  public isDesktop = false;

  public cols = 3;
 // public bodyHeight: number = window.innerHeight - 100;
  public currentPage: PageTypeEnum = PageTypeEnum.Loading;
  public countingUpdate = false;
  public frameSet: IImageFrame[] =
    [
      { id: '001', opacity: 0},
      { id: '002', opacity: 0},
      { id: '003', opacity: 0},
      { id: '004', opacity: 0},
      { id: '005', opacity: 0},
      { id: '006', opacity: 0},
      { id: '007', opacity: 0},
      { id: '008', opacity: 0},
      { id: '009', opacity: 0},
      { id: '010', opacity: 0},
      { id: '011', opacity: 0},
      { id: '012', opacity: 0},
      { id: '013', opacity: 1}
    ];

  public voteAnimation: number[] =
    [12, 0, 1, 2, 3, 4, 5, 6, 2, 3, 4, 5, 6, 2, 3, 4, 5, 6, 2, 3, 7, 8, 9, 10, 11, 12];

  public options = {
    bottom: 0,
    fixed: true,
    top: 100
  };
  public optionsPhone = {
    bottom: 0,
    fixed: true,
    top: 60
  };

  constructor(
  // private myMonitoringService: MyMonitoringService,
    public electionService: ElectionService,
    private changeDetectorRef: ChangeDetectorRef,
    private deviceService: DeviceDetectorService,
    public subTitleService: SubTitleService,
  ) {
    //Hotfix for Dunstan & Black
    //TODO dynamic solution needed for future
    this.subTitleService.updateSubTitle('Dunstan By-Election 2024');
    this.subTitleService.updateSubTitle('Black By-Election 2024');

    this.electionService.pageChanged$.pipe(takeUntil(this.componentDestroyed$)).subscribe(selectPage => {
      this.currentPage = selectPage.pageType;
    });

    this.electionService.voteCountUpdated$.pipe(takeUntil(this.componentDestroyed$)).subscribe(() => {
      if (this.countingUpdate === false) {
        this.playVoteAnimation();
      } 
    });
    this.electionService.subTitleChanged$.pipe(takeUntil(this.componentDestroyed$)).subscribe(subTitle => {
      this.subTitle = subTitle;
      this.changeDetectorRef.detectChanges();
    });

    this.electionService.menuPhoneClick$.pipe(takeUntil(this.componentDestroyed$)).subscribe(() => {
      this.showSideNav = false;
    });
  }


  ngOnInit() {
    this.checkResize();
    fromEvent(window, 'resize').subscribe(e => {
       this.checkResize();
    });
  }

  private checkResize(): void {
    this.isMobile = this.deviceService.isMobile();
    this.isTablet = this.deviceService.isTablet();
    this.isDesktop = this.deviceService.isDesktop();
    this.electionService.isMobile = this.isMobile;
    this.electionService.isTablet = this.isTablet;
    this.electionService.isDesktop = this.isDesktop;
  }

  public playVoteAnimation(): void {
    const timer = interval(100).pipe(
      take(this.voteAnimation.length)
    );
    timer.subscribe(x => {
      if (x === 0) {
        this.countingUpdate = true;
        this.frameSet[this.voteAnimation[this.voteAnimation.length - 1]].opacity = 0;
      } else {
        this.frameSet[this.voteAnimation[x - 1]].opacity = 0;
      }
      this.frameSet[this.voteAnimation[x]].opacity = 1;
      if (x === this.voteAnimation.length - 5) {
        this.countingUpdate = false;
      }
    });
  }


  // doResize() {
  //   const wid = window.innerWidth;
  //   if (wid < 800) {
  //     this.cols = 1;
  //     this.showSideNav = false;
  //     this.bodyHeight = window.innerHeight - 200;
  //   }
  //   else {
  //     this.cols = 3;
  //     this.showSideNav = true;
  //     this.bodyHeight = window.innerHeight - 100;
  //   }
  // }

  toggleSideNav = () => {
    this.showSideNav = !this.showSideNav;
  }

  ngOnDestroy() {
    this.componentDestroyed$.next(true);
    this.componentDestroyed$.complete();
  }

}
